module.exports = __webpack_public_path__ + "img/logo_sm_dark.92a0ab7e.png";